import { WEB_URL } from "../../config/index.js"

const pageMapping = {
    1: "training/details/",
    2: "myApprovals",
    3: "product-management/finishedGoods",
    4: "product-management/parts",
    5: "product-management/type-number",    
    7: "manageuser",
    8: "allowedMaterials",
    9: "warranty/new-ticket",
    10: "policy",
    12: "PFPReport/pay-for-performance-report",
    15: "warranty/sample-collection",
    16: "warranty/proforma-invoice",
    17: "warranty/ticket-upload",
    18:"warranty/ticket-list",
    19: "priceDerivation"
}

export const generateURL = (url_id, entity_id) => {
    let uri = pageMapping[url_id]
    if (uri) {
        switch(url_id) {
        case 1:
            uri += entity_id
            break
        case 7:
            uri += "?entity_id="+entity_id
            break
        case 19:
            uri += "?duplicate="+1
            break
        }
        return `${WEB_URL}${uri}`
    }
    
}
